import type { AdminRolePermissions } from 'src/types/admin';

import useSWR from 'swr';

import { fetcher, endpoints } from 'src/lib/axios';

import { useAuthContext } from 'src/auth/hooks';

export type AdminPermissionsQueryResult = {
  permissions: AdminRolePermissions | undefined;
  isLoading: boolean;
  error: Error | undefined;
  refetch: () => void;
};

export function useAdminPermissionsQuery(): AdminPermissionsQueryResult {
  const { assumedRoleId } = useAuthContext();

  const { data, error, isLoading, isValidating, mutate } = useSWR<AdminRolePermissions>(
    assumedRoleId ? ['me', 'assumed-role', 'permissions', assumedRoleId] : null,
    () => fetcher<AdminRolePermissions>(endpoints.me.assumedRole.permissions)
  );

  const awaitingData = assumedRoleId !== null && data === undefined && !error;

  return {
    permissions: data,
    isLoading: isLoading || isValidating || awaitingData,
    error,
    refetch: mutate,
  };
}
